
<template>

    <div>
       <vs-button @click="popupActivo2=true" icon-pack="feather" icon="icon-plus" type="flat" class="w-full">Folder</vs-button>
       <br>
       <vs-popup classContent="popup-example"  title="Create folder" :active.sync="popupActivo2">
                
          <vs-input placeholder="Folder Name" v-model="data.repository_name" class="mt-5 w-full"/>
      
      <vs-button class="mt-5 w-full" :disabled="buttonActive" @click="onEnter" color="primary" type="filled">Create</vs-button>
      
    </vs-popup>
 
    </div>
</template>

<script>

import {create_folder, folder_list } from '@/api/file.js'
export default {
  name: 'createfolder',
  props: ['repo_id', 'repository_name'],
  data () {
    return {
      data: {
        repository_name: '',
        repository_path: '',
        parent_repository_id: ''
      },
      popupActivo2: false,
      buttonActive: false
    }
  },
  methods: {
    addedFolder (allFolder) {
      this.$emit('addedFolder', allFolder)
    },
    onEnter () {
      // eslint-disable-next-line eqeqeq
      if (this.data.repository_name != '') {
        this.buttonActive = true
        this.data.repository_path = `${this.repository_name}/${this.data.repository_name}`
        this.data.parent_repository_id = this.repo_id
        create_folder(localStorage.getItem('customer_id'), this.data)
          .then((res) => {
            
            this.$vs.notify({
              title: 'Success',
              text: 'Your folder is created',
              color: 'success',
              iconPack: 'feather',
              icon: 'icon-alert-circle'
            })
            folder_list(localStorage.getItem('customer_id'))
              .then((res) => {
              //
                this.popupActivo2 = false
                this.data.repository_name = ''
                this.buttonActive = false
                this.addedFolder(res.data.data.repository)
              })
              .catch((e) => {
                
                this.popupActivo2 = false
                this.data.repository_name = ''
                this.buttonActive = false
                this.$vs.notify({
                  title: 'Warning',
                  text: 'Something Went Wrong',
                  color: 'warning',
                  iconPack: 'feather',
                  icon: 'icon-alert-circle'
                })
              })
          })
          .catch((e) => {
            
            this.popupActivo2 = false
            this.data.repository_name = ''
            this.buttonActive = false
            this.$vs.notify({
              title: 'Warning',
              text: 'Something Went Wrong',
              color: 'warning',
              iconPack: 'feather',
              icon: 'icon-alert-circle'
            })
          })
      }
    }

  }
}
</script>